import { useNavigate } from 'react-router-dom';
import styles from './MomentumStrip.module.css';

const RARITY_COLOR = { bronze: '#8B5E3C', silver: '#A8B0B8', gold: '#C8A84B', legendary: '#FFD700' };
const NEXT_RARITY  = { bronze: 'Silver', silver: 'Gold', gold: 'Gold' };

function formatCountdown(nextRetryAt) {
    if (!nextRetryAt) return null;
    const ms  = new Date(nextRetryAt).getTime() - Date.now();
    if (ms <= 0) return null;
    const h   = Math.floor(ms / 3600000);
    const m   = Math.floor((ms % 3600000) / 60000);
    return h > 0 ? `${h}h ${m}m` : `${m}m`;
}

function MomentumCard({ card }) {
    const navigate = useNavigate();

    const handleClick = () => {
        if (card.media) navigate(`/movie/${card.media.kind}/${card.media.tmdbId}`);
        if (card.collectionSlug) navigate(`/collections/${card.collectionSlug}`);
    };

    if (card.type === 'upgrade_available') {
        const color = RARITY_COLOR[card.currentRarity] || '#888';
        return (
            <button className={styles.card} onClick={handleClick} style={{ '--accent': color }}>
                {card.media?.posterUrl && <img src={card.media.posterUrl} alt="" className={styles.poster} />}
                <div className={styles.cardBody}>
                    <span className={styles.cardTag} style={{ color }}>⬆️ Upgrade Ready</span>
                    <p className={styles.cardTitle}>{card.media?.title ?? '—'}</p>
                    <p className={styles.cardSub}>
                        <span style={{ color }}>{card.currentRarity.charAt(0).toUpperCase() + card.currentRarity.slice(1)}</span>
                        {' → '}
                        <strong>{NEXT_RARITY[card.currentRarity]}</strong>
                    </p>
                </div>
            </button>
        );
    }

    if (card.type === 'cooldown_active') {
        const countdown = formatCountdown(card.nextRetryAt);
        return (
            <div className={styles.card} style={{ '--accent': '#555', opacity: 0.6 }}>
                {card.media?.posterUrl && <img src={card.media.posterUrl} alt="" className={styles.poster} />}
                <div className={styles.cardBody}>
                    <span className={styles.cardTag} style={{ color: '#888' }}>⏳ Cooldown</span>
                    <p className={styles.cardTitle}>{card.media?.title ?? '—'}</p>
                    {countdown && <p className={styles.cardSub}>Unlocks in <strong>{countdown}</strong></p>}
                </div>
            </div>
        );
    }

    if (card.type === 'collection_in_progress') {
        return (
            <button className={styles.card} onClick={handleClick} style={{ '--accent': '#FFD700' }}>
                <div className={styles.collectionIcon}>🏛️</div>
                <div className={styles.cardBody}>
                    <span className={styles.cardTag} style={{ color: '#FFD700' }}>Collection</span>
                    <p className={styles.cardTitle}>{card.collectionName}</p>
                    <p className={styles.cardSub}>✦ Legendary awaits</p>
                </div>
            </button>
        );
    }

    return null;
}

export default function MomentumStrip({ momentum, loading }) {
    if (loading) return <div className={styles.skeleton} />;

    const cards = [
        ...(momentum?.upgradeCards    ?? []),
        ...(momentum?.collectionCards ?? []),
        ...(momentum?.cooldownCards   ?? []),
    ];

    if (!cards.length) return null;

    return (
        <section className={styles.section}>
            <h2 className={styles.sectionTitle}>⚡ Your Momentum</h2>
            <div className={styles.strip}>
                {cards.map((card, i) => <MomentumCard key={i} card={card} />)}
            </div>
        </section>
    );
}